module.exports = __webpack_public_path__ + "static/img/1.ad7cf21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020-1.31/1.jpg
// module id = EO9l
// module chunks = 1